import { MAIN_ENDPOINT } from "../../../config/api-client";

export const QUERY_KEY = "roadmaps";
export const ENDPOINT = MAIN_ENDPOINT;
